/* globals fbq */
let AnalyticsException = require('./analytics-exception');

class FacebookAnalytics {
  /**
   * Create an instance of the class
   *
   * @param {String} apiKey
   */
  constructor (apiKey) {
    if (typeof fbq === 'undefined') {
      throw new AnalyticsException(
        'Cannot find Facebook Pixel Analytics (fbq) service'
      );
    }

    this.apiKey = apiKey;

    // this is usually initialized elsewhere and unfortunately there is
    // not a reliable way currently to check if it has been
    // this.init();
  }

  /**
     * Initialize the Facebook Pixel tracker
     */
  init () {
    fbq('init', this.apiKey);
    fbq('track', 'PageView');
  }

  /**
     * Track the given event
     *
     * @param {String}
     * @param {String}
     * @param {Number}
     * @param {String}
     */
  track (event, name, value = 0.00, currency = 'USD') {
    fbq('track', event, {
      value: value,
      currency: currency,
      content_name: name
    });
  }
}

module.exports = FacebookAnalytics;
